import { useEffect, useState } from 'react';
import { applyTheme, resolveInitialTheme, saveTheme, type ZaptorTheme } from '@/lib/theme';

export function useTheme() {
  const [theme, setThemeState] = useState<ZaptorTheme>(() => resolveInitialTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  function setTheme(next: ZaptorTheme) {
    saveTheme(next);
    setThemeState(next);
  }

  function toggle() {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  }

  return { theme, setTheme, toggle };
}
